import { RequestKind, boolean, number, string } from '@sb/library/base';
import { DisplayItemCollection, EventLocationDisplayItem, EventLocationInputItem, EventLocationSearchOptions, EventLocationUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace EventLocationRoutes {
    export const Get = ApiRoute.Define({
        URL: (eventLocationID: string) => `eventlocations/${eventLocationID}`,
        Kind: RequestKind.Get,
        ResultType: EventLocationDisplayItem
    });

    export const GetAll = ApiRoute.Define({
        URL: `eventlocations`,
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<EventLocationDisplayItem>
    });

    export const GetCount = ApiRoute.Define({
        URL: (locationID: string) => `summary/eventlocations/${locationID}/count`,
        Kind: RequestKind.Get,
        ResultType: number
    });

    export const Update = ApiRoute.Define({
        URL: (locationID: string) => `eventlocations/${locationID}`,
        BodyType: EventLocationUpdateItem,
        Kind: RequestKind.Put,
        ResultType: boolean
    });

    export const Add = ApiRoute.Define({
        URL: `eventlocations`,
        BodyType: EventLocationInputItem,
        Kind: RequestKind.Post,
        ResultType: string
    });

    export const Delete = ApiRoute.Define({
        URL: (locationID: string) => `eventlocations/${locationID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const Search = ApiRoute.Define({
        URL: 'search/eventlocations',
        Kind: RequestKind.Post,
        BodyType: EventLocationSearchOptions,
        PagingAllowed: true,
        ResultType: DisplayItemCollection<EventLocationDisplayItem>
    });
}
